"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selector = exports.Passenger = exports.IconStyled = exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _Icon = _interopRequireDefault(require("../Icon"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Container = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  align-items    : center;\n  color          : ", ";\n  display        : flex;\n  font-size      : 20px;\n  justify-content: space-between;\n  width          : ", ";\n"])), _palette.palette.bobBlack, function (props) {
  return props.width ? typeof props.width === 'string' ? "".concat(props.width) : "".concat(props.width, "px") : undefined;
});

exports.Container = Container;
Container.displayName = 'Container';
var IconStyled = (0, _styledComponents["default"])(_Icon["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items    : center;\n  border         : ", " solid 1px;\n  border-radius  : 100px;\n  display        : flex;\n  height         : 40px;\n  justify-content: center;\n  width          : 40px;\n\n  ", "\n\n  ", "\n\n  &:hover {\n    cursor: pointer;\n  }\n"])), _palette.palette.bobBlack, function (props) {
  return props.disabled && "\n    border         : ".concat(_palette.palette.lightGrey, " solid 1px;\n    pointer-events: none;\n  ");
}, function (props) {
  return props.error && "\n    border         : ".concat(_palette.palette.error, " solid 1px;\n  ");
});
exports.IconStyled = IconStyled;
IconStyled.displayName = 'IconStyled';

var Passenger = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  font-size  : 16px;\n  font-weight: ", ";\n"])), _widths.font.semi);

exports.Passenger = Passenger;
Passenger.displayName = 'Passenger';

var Selector = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items    : center;\n  display        : flex;\n  justify-content: space-between;\n  user-select    : none;\n  min-width      : 128px;\n"])));

exports.Selector = Selector;
Selector.displayName = 'Selector';